export default __webpack_public_path__ + "static/media/53-Point-of-Use-Panels.e95d2517.jpg";